const askquestion = {
  // Header Section
  "discover_your": "உங்கள்",
  "ask_question": "கேள்வி கேளுங்கள்",
  "personalized_answers": "தனிப்பயன் ஜோதிடப் பதில்கள்",
  "ask_question_description": "உங்கள் வாழ்க்கை குறித்த எந்தக் குறிப்பிட்ட கேள்வியையும் கேட்டு விரிவான ஜோதிடப் பதில்களைப் பெறுங்கள். உங்கள் ஜாதகத்தின் அடிப்படையில் எங்கள் நிபுணர் ஜோதிடர்கள் நடைமுறை வழிகாட்டுதலும் பரிகாரங்களும் கொண்ட தனிப்பயன் நுண்ணறிவுகளை வழங்குவார்கள்.",

  // Service Information
  "enter_details_for_question": "உங்கள் விவரங்களையும் கேள்வியையும் உள்ளிடுங்கள்",
  "personalized_question_answer": "தனிப்பயன் கேள்வி-பதில்",
  "service_price": "சேவை விலை",
  "personalized_question_answer_note": "உங்கள் குறிப்பிட்ட கேள்விக்கு நிபுணர் ஜோதிடப் பதில் மற்றும் வழிகாட்டுதல்",

  // Form Fields
  "full_name": "முழுப் பெயர்",
  "enter_full_name": "உங்கள் முழுப் பெயரை உள்ளிடுங்கள்",
  "name_question_context": "உங்கள் பெயர், கேள்விக்கான தனிப்பயன் சூழலை வழங்க உதவும்",
  "email_address": "மின்னஞ்சல் முகவரி",
  "enter_email_address": "உங்கள் மின்னஞ்சல் முகவரியை உள்ளிடுங்கள்",
  "phone_number": "தொலைபேசி எண்",
  "enter_phone_number": "உங்கள் தொலைபேசி எண்ணை உள்ளிடுங்கள்",
  "gender": "பாலினம்",
  "male": "ஆண்",
  "female": "பெண்",
  "other": "மற்றவை",
  "date_of_birth": "பிறந்த தேதி",
  "birth_date_question_context": "ஜோதிடச் சூழலும் துல்லிய பதிலும் பெற இவை அவசியம்",
  "your_question": "உங்கள் கேள்வி",
  "enter_your_question": "உங்கள் குறிப்பிட்ட கேள்வியை இங்கு உள்ளிடுங்கள்...",
  "question_guidance": "தெளிவாகவும் குறிப்பிட்டவாறும் கேளுங்கள். தொழில், காதல், நிதி, ஆரோக்கியம், குடும்பம் அல்லது வாழ்க்கை தொடர்பான எதையும் கேட்கலாம்",
  "question_category": "கேள்வி வகை",
  "select_category": "கேள்வி வகையைத் தேர்ந்தெடுக்கவும்",
  "career_question": "தொழில் & வணிகம்",
  "love_relationship_question": "காதல் & உறவுகள்",
  "finance_question": "நிதி & பணம்",
  "health_question": "ஆரோக்கியம் & நலன்",
  "family_question": "குடும்பம் & தனிப்பட்டவை",
  "spiritual_question": "ஆன்மீகம் & வளர்ச்சி",
  "general_question": "பொது வாழ்க்கை",
  "category_helps_accuracy": "வகைத் தேர்வு, அதிகத் துல்லியமான மற்றும் தொடர்புடைய பதில்களுக்கு உதவும்",
  "preferred_language": "விருப்ப மொழி",
  "english": "ஆங்கிலம்",
  "hindi": "ஹிந்தி",
  "telugu": "தெலுங்கு",
  "kannada": "கன்னடம்",
  "language_note": "உங்கள் பதில் தேர்ந்தெடுத்த மொழியில் வழங்கப்படும்",

  // Core Question Features
  "detailed_answer_explanation": "விரிவான பதில் & விளக்கம்",
  "astrological_context": "ஜோதிடச் சூழல்",
  "timing_guidance": "காலநேர வழிகாட்டுதல்",
  "remedial_suggestions": "பரிகார பரிந்துரைகள்",
  "follow_up_guidance": "பின்தொடரும் வழிகாட்டல்",
  "pdf_answer_report": "PDF பதில் அறிக்கை",

  "what_you_get": "உங்கள் பதிலில் உள்ளவை",
  "comprehensive_answer": "முழுமையான பதில்",
  "astrological_insights": "ஜோதிட நுண்ணறிவுகள்",
  "practical_guidance": "நடைமுறை வழிகாட்டுதல்",
  "remedial_solutions": "பரிகாரத் தீர்வுகள்",

  // Actions & Buttons
  "pay_and_get_answer": "என் பதிலைப் பெறவும்",
  "processing_payment": "கட்டணம் செயலாக்கப்படுகிறது",
  "processing_request": "கேள்வி செயலாக்கப்படுகிறது",

  // Payment & Success Messages
  "thank_you": "நன்றி",
  "payment_successful": "கட்டணம் வெற்றிகரமாக முடிந்தது!",
  "question_answer_processing": "உங்கள் கேள்வியை எங்கள் நிபுணர் ஜோதிடர்கள் பகுப்பாய்வு செய்து வருகின்றனர். ஜோதிட நுண்ணறிவுகளும் நடைமுறை வழிகாட்டுதல்களும் கொண்ட விரிவான தனிப்பயன் பதிலைப் பெறுவீர்கள்.",
  "order_id": "ஆர்டர் ஐடி",
  "payment_id": "கட்டணம் ஐடி",
  "amount_paid": "செலுத்திய தொகை",

  // Delivery Information
  "delivery_information": "விநியோக தகவல்",
  "delivery_time": "பதில் விநியோகம்",
  "within_6_hours_delivery_note": "உங்கள் விரிவான பதில் 6 மணிநேரத்திற்குள் தயார் ஆகும்",
  "whatsapp_notification": "WhatsApp புதுப்பிப்புகள்",
  "whatsapp_delivery_note": "WhatsApp-ல் உடனடி அறிவிப்புகள் பெறுங்கள்",
  "email_delivery": "மின்னஞ்சல் விநியோகம்",
  "email_delivery_note": "முழு பதில் அனுப்பப்படும் முகவரி",

  // What You'll Receive
  "what_youll_receive": "உங்கள் பதில் தொகுப்பு",
  "detailed_answer_report_pdf": "விரிவான பதில் அறிக்கை (PDF)",
  "astrological_explanation": "ஜோதிட விளக்கம்",
  "timing_recommendations": "காலநேர பரிந்துரைகள்",
  "remedial_measures": "பரிகார வழிமுறைகள்",
  "action_plan_guidance": "செயல் திட்ட வழிகாட்டுதல்",

  // Visual Content
  "sample_question_answer": "மாதிரி கேள்வி-பதில்",
  "expert_answer": "நிபுணர் பதில்",
  "sample_answer_preview": "ஜோதிட நுண்ணறிவுகளுடன் நடைமுறை வழிகாட்டலும் நேர வழிகாட்டலும்",
  "sample_question_preview": "உங்கள் குறிப்பிட்ட கேள்விகளுக்கு எங்கள் நிபுணர்கள் எப்படி பதிலளிப்பதை முன்னோட்டமாகப் பாருங்கள்",
  "question_categories": "கேள்வி வகைகள்",

  // Question Category Types
  "career": "தொழில்",
  "love": "காதல்",
  "finance": "நிதி",
  "health": "ஆரோக்கியம்",
  "family": "குடும்பம்",
  "spiritual": "ஆன்மீகம்",

  // Status & Processing
  "your_question_status": "உங்கள் கேள்வியின் நிலை",
  "processing_your_question": "உங்கள் கேள்வி ஆய்வு செய்யப்படுகிறது",
  "question_processing_message": "அதிகத் துல்லியமான மற்றும் பயனுள்ள பதிலை வழங்க உங்கள் ஜாதகமும் கேள்வியும் எங்கள் நிபுணர்களால் பகுப்பாய்வு செய்யப்படுகிறது.",
  "request_id": "கேள்வி ஐடி",
  "status": "நிலை",
  "processing": "நடைபெறுகிறது",
  "pending": "வரிசையில் உள்ளது",
  "email_notification_sent": "உறுதிப்படுத்தும் மின்னஞ்சல் அனுப்பப்பட்டது",
  "whatsapp_update_coming": "WhatsApp புதுப்பிப்புகள் இயலுமைப்படுத்தப்பட்டுள்ளன",
  "delivery_within_6_hours": "பதில் 6 மணிநேரத்தில் தயார்",

  // Support & Contact
  "contact_support": "கேள்வி ஆதரவைத் தொடர்புகொள்ளுங்கள்",
  "need_help": "வழிகாட்டல் வேண்டுமா?",
  "contact_us_at": "எங்களை அணுக",

  // Error Messages
  "please_fill_all_required_fields": "உங்கள் கேள்வியையும் சேர்த்து தேவையான அனைத்து புலங்களையும் நிரப்புங்கள்",
  "payment_failed": "கட்டணம் தோல்வியடைந்தது. தயவு செய்து மீண்டும் முயற்சிக்கவும்.",
  "processing_failed": "கேள்வி செயலாக்கம் தோல்வியடைந்தது. எங்கள் ஆதரவுடன் தொடர்புகொள்ளுங்கள்.",

  // Question Types & Examples
  "career_questions_examples": "தொழில் கேள்விகள் — உதாரணங்கள்",
  "when_promotion": "எப்போது பதவி உயர்வு கிடைக்கும்?",
  "job_change_timing": "இப்போது வேலை மாற்றலாமா?",
  "business_success": "என் வணிகம் வெற்றி பெறுமா?",
  "career_path": "எனக்கு எது சரியான தொழில் பாதை?",

  "love_questions_examples": "காதல் கேள்விகள் — உதாரணங்கள்",
  "marriage_timing": "எப்போது திருமணம் நடக்கும்?",
  "relationship_future": "என் உறவின் எதிர்காலம் எப்படி இருக்கும்?",
  "soulmate_meeting": "எப்போது என் ஆன்மத் துணையை சந்திப்பேன்?",
  "love_compatibility_question": "நாங்கள் திருமணத்திற்கு இணக்கமா?",

  "finance_questions_examples": "நிதி கேள்விகள் — உதாரணங்கள்",
  "money_problems": "எப்போது என் நிதி சிக்கல்கள் தீரும்?",
  "investment_timing": "இப்போது முதலீடு செய்யலாமா?",
  "property_purchase": "இப்போது சொத்து வாங்கலாமா?",
  "debt_relief": "எப்போது நான் கடனிலிருந்து விடுபடுவேன்?",

  "health_questions_examples": "ஆரோக்கிய கேள்விகள் — உதாரணங்கள்",
  "health_recovery": "எப்போது என் ஆரோக்கியம் மேம்படும்?",
  "surgery_timing": "அறுவை சிகிச்சைக்கு இப்போது நேரமா?",
  "chronic_illness": "என் நீடித்த நோய் குணமாகுமா?",
  "fitness_goals": "என் ஆரோக்கிய இலக்குகளை எப்படி அடைவேன்?",

  // Answer Components
  "question_analysis": "கேள்வி பகுப்பாய்வு",
  "birth_chart_insights": "ஜாதக நுண்ணறிவுகள்",
  "planetary_influences": "கிரகத் தாக்கங்கள்",
  "current_transits": "தற்போதைய கோச்சாரத் தாக்கங்கள்",
  "dasha_analysis": "தசா காலப் பகுப்பாய்வு",
  "yogas_doshas": "சம்பந்தப்பட்ட யோகங்கள் & தோஷங்கள்",

  // Timing Analysis
  "favorable_periods": "சாதகமான காலங்கள்",
  "challenging_periods": "சவாலான காலங்கள்",
  "optimal_timing": "சிறந்த நேரம்",
  "avoid_periods": "தவிர்க்க வேண்டிய காலங்கள்",
  "gradual_improvement": "ஒருங்கேற்ற மேம்பாடு — காலவரிசை",
  "sudden_changes": "திடீர் மாற்றங்கள் — சாத்தியங்கள்",

  // Remedial Solutions
  "gemstone_remedies": "ரத்தின பரிகாரங்கள்",
  "mantra_recommendations": "மந்திர பரிந்துரைகள்",
  "charity_suggestions": "தான தர்ம பரிந்துரைகள்",
  "ritual_guidance": "பூஜை & அனுஷ்டான வழிகாட்டுதல்",
  "lifestyle_changes": "வாழ்க்கைமுறை மாற்றங்கள்",
  "behavioral_adjustments": "நடத்தை மாற்ற வழிகாட்டுதல்",

  // Practical Guidance
  "action_steps": "பரிந்துரைக்கப்பட்ட செயல் படிகள்",
  "do_and_dont": "செய்ய வேண்டியது & செய்யக் கூடாதது",
  "precautions": "எடுக்க வேண்டிய முன்னெச்சரிக்கைகள்",
  "opportunities": "கவனிக்க வேண்டிய வாய்ப்புகள்",
  "preparation_tips": "தயாரிப்பு குறிப்புகள்",
  "patience_guidance": "எப்போது பொறுமை அவசியம்",

  // Follow-up Information
  "progress_tracking": "முன்னேற்ற கண்காணிப்பு",
  "reassessment_timing": "மீள்மதிப்பீடு செய்ய வேண்டிய நேரம்",
  "additional_questions": "சம்பந்தப்பட்ட கூடுதல் கேள்விகள்",
  "ongoing_guidance": "தொடர்ந்த வழிகாட்டுதல்",
  "support_resources": "ஆதரவு வளங்கள்",
  "expert_consultation": "நிபுணர் ஆலோசனை கிடைக்கும்",

  // Question Quality Guidelines
  "specific_questions": "குறிப்பிட்ட கேள்விகளை கேளுங்கள்",
  "avoid_yes_no": "எளிய ஆம்/இல்லை கேள்விகளை தவிர்க்கவும்",
  "include_context": "தொடர்புடைய சூழலை சேர்க்கவும்",
  "one_main_question": "ஒரு முக்கிய கேள்வியில் கவனம் செலுத்தவும்",
  "clear_timeline": "ஆவலான காலவரிசையை குறிப்பிடவும்",
  "personal_concerns": "தனிப்பட்ட கவலைகளை வெளிப்படுத்தவும்",

  // Answer Accuracy Factors
  "birth_time_accuracy": "பிறந்த நேரத் துல்லியம் முக்கியம்",
  "current_circumstances": "தற்போதைய வாழ்க்கை சூழல்கள்",
  "personal_efforts": "தனிப்பட்ட முயற்சிகள் முக்கியம்",
  "free_will_factor": "சுயஇச்சை காரணிகள்",
  "karmic_influences": "கர்மத் தாக்கங்கள்",
  "divine_grace": "தெய்வ அனுக்ரஹக் காரணம்",

  // Special Question Categories
  "urgent_questions": "அவசர வாழ்க்கை கேள்விகள்",
  "long_term_planning": "நீண்டகால வாழ்க்கைத் திட்டமிடல்",
  "decision_making": "முக்கிய முடிவு எடுப்பது",
  "crisis_management": "அவசரநிலை & சவால் மேலாண்மை",
  "opportunity_evaluation": "வாய்ப்பு மதிப்பீடு",
  "relationship_counseling": "உறவு வழிகாட்டுதல்",

  // Confidentiality
  "privacy_assurance": "முழுமையான தனியுரிமை உறுதி",
  "confidential_handling": "ரகசிய கேள்வி கையாளுதல்",
  "secure_communication": "பாதுகாப்பான தொடர்பாடல்",
  "expert_discretion": "நிபுணர் விநயத்துடன் அணுகுதல்",
  "no_judgment": "தீர்ப்பில்லா அணுகுமுறை",
  "supportive_guidance": "ஆதரவான & கருணையுள்ள வழிகாட்டுதல்"
};

export default askquestion;
